const orangeA = {
  orangeA1: "hsla(20, 94.9%, 38.7%, 0.016)",
  orangeA2: "hsla(24, 95.8%, 46.5%, 0.044)",
  orangeA3: "hsla(25, 100%, 50.5%, 0.095)",
  orangeA4: "hsla(26, 100%, 50.0%, 0.157)",
  orangeA5: "hsla(25, 100%, 50.1%, 0.236)",
  orangeA6: "hsla(25, 100%, 50.1%, 0.346)",
  orangeA7: "hsla(24, 100%, 50.1%, 0.495)",
  orangeA8: "hsla(24, 99.7%, 48.7%, 0.695)",
  orangeA9: "hsla(24, 99.9%, 48.4%, 0.969)",
  orangeA10: "hsla(23, 100%, 46.4%, 0.980)",
  orangeA11: "hsla(23, 100%, 36.8%, 0.980)",
  orangeA12: "hsla(15, 99.4%, 11.0%, 0.934)"
};
export { orangeA };
//# sourceMappingURL=orangeA.mjs.map
